import { useEffect } from "react";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setLanguage } from "../../redux/Slices/languageSlice";
import type { AppDispatch } from "../../redux/store";
import { VALID_LANGS, LangCode } from "../../constants/route-slugs";

const LangWrapper = () => {
  const { lang } = useParams<{ lang: string }>();
  const dispatch = useDispatch<AppDispatch>();

  const isValid = lang !== undefined && VALID_LANGS.includes(lang as LangCode);

  useEffect(() => {
    if (!isValid) return;

    dispatch(setLanguage(lang!));
    document.documentElement.lang = lang!;

    // hreflang alternate link tags
    const base = "https://colibri.az";
    const pathWithoutLang = window.location.pathname.replace(/^\/(az|en|ru)/, "");
    const pairs: [string, string][] = [
      ["az", `${base}/az${pathWithoutLang}`],
      ["en", `${base}/en${pathWithoutLang}`],
      ["ru", `${base}/ru${pathWithoutLang}`],
      ["x-default", `${base}/az${pathWithoutLang}`],
    ];

    // remove old hreflang tags
    document.head
      .querySelectorAll('link[rel="alternate"][hreflang]')
      .forEach((el) => el.remove());

    pairs.forEach(([hreflang, href]) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.setAttribute("hreflang", hreflang);
      link.href = href;
      document.head.appendChild(link);
    });
  }, [lang, isValid, dispatch]);

  if (!isValid) {
    const fallback = localStorage.getItem("language") || "az";
    return <Navigate to={`/${fallback}`} replace />;
  }

  return <Outlet />;
};

export default LangWrapper;
